import { useState } from "react";
import { getEndpoints, getToken, setEndpoints, setToken } from "../lib/api";

export function Settings({
  firstRun = false,
  onSaved
}: {
  firstRun?: boolean;
  onSaved: () => void;
}) {
  const initialEndpoints = getEndpoints();
  const [token, setTokenLocal] = useState(getToken());
  const [reportBase, setReportBase] = useState(initialEndpoints.reportBase);
  const [askBase, setAskBase] = useState(initialEndpoints.askBase);
  const [saved, setSaved] = useState(false);

  function onSubmit(e: React.FormEvent) {
    e.preventDefault();
    setToken(token.trim());
    setEndpoints({ reportBase: reportBase.trim(), askBase: askBase.trim() });
    setSaved(true);
    onSaved();
  }

  return (
    <div className={firstRun ? "min-h-screen bg-canvas" : ""}>
      {firstRun && (
        <div className="bg-black px-6 py-section text-white">
          <div className="mx-auto max-w-3xl">
            <h1 className="text-hero">Health</h1>
            <p className="mt-6 text-lead text-white/72">
              Cá nhân · Apple Watch + 3 BS AI
            </p>
          </div>
        </div>
      )}

      <section className="bg-canvas px-6 py-section md:px-12">
        <div className="mx-auto max-w-2xl">
          <h2 className="text-displayLg">{firstRun ? "Bắt đầu" : "Cài đặt"}</h2>
          <p className="mt-4 text-bodyApple text-ink-muted80">
            {firstRun
              ? "Trước khi xem báo cáo đầu tiên, anh dán bearer token + worker URL."
              : "Cấu hình token + endpoint của workers."}
          </p>

          <form onSubmit={onSubmit} className="mt-12 space-y-8">
            <Field
              label="APP_BEARER_TOKEN"
              hint="Random 32+ ký tự, set trong cả 2 worker bằng `wrangler secret put APP_BEARER_TOKEN`."
              value={token}
              onChange={setTokenLocal}
              type="password"
            />
            <Field
              label="Daily Report Worker URL"
              hint="VD: https://personal-health-daily-report.<sub>.workers.dev"
              value={reportBase}
              onChange={setReportBase}
            />
            <Field
              label="Multi-LLM Worker URL"
              hint="VD: https://personal-health-multi-llm.<sub>.workers.dev"
              value={askBase}
              onChange={setAskBase}
            />

            <div className="flex items-center gap-4">
              <button
                type="submit"
                className="apple-press rounded-pill bg-action px-7 py-3 text-bodyApple text-white"
              >
                Lưu
              </button>
              {saved && !firstRun && (
                <span className="text-captionApple text-ink-muted48">Đã lưu</span>
              )}
            </div>
          </form>
        </div>
      </section>

      <section className="bg-canvas-parchment px-6 py-section md:px-12">
        <div className="mx-auto max-w-2xl">
          <h3 className="text-displayMd">Setup checklist</h3>
          <ol className="mt-10 space-y-4 text-bodyApple text-ink-muted80">
            <li>
              <span className="font-semibold text-ink">1.</span> Tạo D1: <code>npx wrangler d1 create personal-health</code>, paste id vào 3 wrangler.toml
            </li>
            <li>
              <span className="font-semibold text-ink">2.</span> Tạo R2: <code>npx wrangler r2 bucket create personal-health-raw</code>
            </li>
            <li>
              <span className="font-semibold text-ink">3.</span> Apply migrations: <code>pnpm --filter @personal/health-ingest migrate:remote</code>
            </li>
            <li>
              <span className="font-semibold text-ink">4.</span> Set secrets cho 3 workers: <code>INGEST_BEARER_TOKEN</code> (ingest), <code>APP_BEARER_TOKEN</code> + <code>ANTHROPIC_API_KEY</code> (daily-report + multi-llm), <code>OPENAI_API_KEY</code> + <code>GOOGLE_AI_API_KEY</code> (multi-llm).
            </li>
            <li>
              <span className="font-semibold text-ink">5.</span> Cài Health Auto Export trên iPhone, set webhook URL = ingest worker, Bearer = INGEST_BEARER_TOKEN.
            </li>
            <li>
              <span className="font-semibold text-ink">6.</span> Bật Cloudflare Access cho Pages app (chỉ duywin@gmail.com).
            </li>
          </ol>
        </div>
      </section>
    </div>
  );
}

function Field({
  label,
  hint,
  value,
  onChange,
  type = "text"
}: {
  label: string;
  hint?: string;
  value: string;
  onChange: (s: string) => void;
  type?: string;
}) {
  return (
    <div>
      <label className="block text-captionStrong text-ink">{label}</label>
      <input
        type={type}
        value={value}
        onChange={(e) => onChange(e.target.value)}
        className="mt-3 w-full rounded-md border border-hairline bg-canvas px-4 py-3 text-bodyApple tnum text-ink focus:border-action focus:outline-none focus:ring-2 focus:ring-action/20"
      />
      {hint && <p className="mt-2 text-captionApple text-ink-muted48">{hint}</p>}
    </div>
  );
}
